import React from 'react';
import PropTypes from 'prop-types';
import Column from 'components/ui/show/Column';
import InnerColumn from 'components/ui/show/InnerColumn';
import Row from 'components/list/Filters/layout/Row';
import Section from 'components/ui/general/Section';
import TextInputField from 'material-ui/TextField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

class MultiFieldConfiguration extends React.Component {
    render() {
        const {
            errors,
            hintText,
            onChangeInput,
            title,
            translate,
            translationKey,
            values,
        } = this.props;

        return (
            <Section>
                <Column title={ title }>
                    <InnerColumn>
                        { utils.map(values, (value, property) => {
                            return (
                                <Row key={ `configuration-${ property }` }>
                                    <TextInputField
                                        floatingLabelText={ translate(`${ translationKey }.${ property }`) }
                                        errorText={ errors[property] || null }
                                        name={ property }
                                        hintText={ hintText }
                                        onChange={ onChangeInput }
                                        type='text'
                                        value={ value }
                                    />
                                </Row>
                            );
                        })}
                    </InnerColumn>
                </Column>
            </Section>
        );
    }
}

MultiFieldConfiguration.propTypes = {
    errors: PropTypes.object,
    hintText: PropTypes.string,
    onChangeInput: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    translationKey: PropTypes.string.isRequired,
    values: PropTypes.object,
};

export default translate(MultiFieldConfiguration);


// WEBPACK FOOTER //
// ./src/pages/products/configuration/MultiFieldConfiguration.js